/* ==========================================================================
   KeraBiotic Consumer Study — multi-step application controller (vanilla JS).
   Ported from the Claude Design prototype (study-app.jsx). Mirrors its flow,
   validation, persistence and share, but operates on server-rendered DOM.

   Privacy: the pregnancy / medical answers are a CLIENT-SIDE eligibility
   pre-screen. They are NEVER transmitted — and nothing derived from them is
   either, since any such flag would disclose the answer 1:1 (Art. 9 data).
   On submit we send only the marketing-safe profile fields.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-study]');
  if (!root) return;

  var STORE = 'kerabiotic_study_v1';
  var TOTAL = 5;
  var WIDE_MIN = parseInt(root.getAttribute('data-wide-min'), 10) || 760;
  var LIST_ID = (root.getAttribute('data-list-id') || '').trim();
  var TAG = (root.getAttribute('data-tag') || '').trim();

  // Goal options come from the Liquid registry (`[data-study-config]`) so the list
  // lives in exactly one place — see the goals_rows comment in the section file.
  // Falls back to reading the rendered buttons if the registry is ever missing.
  var CFG = (function () {
    var el = root.querySelector('[data-study-config]');
    var c = null;
    if (el) { try { c = JSON.parse(el.textContent); } catch (e) {} }
    if (!c) c = {};
    if (!c.goals || !c.goals.length) {
      c.goals = Array.prototype.map.call(root.querySelectorAll('[data-multi="goals"] [data-value]'), function (b) {
        var l = b.querySelector('.study-option__label');
        return { key: b.getAttribute('data-value'), label: l ? l.textContent.trim() : '' };
      });
    }
    c.goalsMax = c.goalsMax || 3;
    return c;
  })();
  var GOALS_MAX = CFG.goalsMax;

  function goalLabel(v) { for (var i = 0; i < CFG.goals.length; i++) { if (CFG.goals[i].key === v) return CFG.goals[i].label; } return null; }
  function isGoalKey(v) { return goalLabel(v) !== null; }

  var EMPTY = {
    email: '', fullName: '',
    ageRange: '', gender: '',
    goals: [],
    pregnant: '', medicalNote: '', medicalNone: false,
    consentContact: false, consentMarketing: false
  };

  // ---- DOM refs ----
  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  var screens = {
    welcome: $('[data-screen="welcome"]'),
    form: $('[data-screen="form"]'),
    thanks: $('[data-screen="thanks"]')
  };
  var stepEls = $$('[data-step]');
  var progressSegs = $$('[data-progress] .study-progress__seg');
  var counterEl = $('[data-counter-current]');
  var backBtn = $('[data-action="back"]');
  var nextBtn = $('[data-action="next"]');
  var nextLabel = $('[data-next-label]');
  var nextArrow = $('[data-next-arrow]');
  var formBody = $('[data-form-body]');
  var summaryEl = $('[data-summary]');
  var thanksTitle = $('[data-thanks-title]');
  var pregnantNotice = $('[data-notice="pregnant"]');
  var medicalTextarea = $('[data-key="medicalNote"]');

  // submit error line (created lazily, lives above the Next button)
  var submitError = document.createElement('p');
  submitError.className = 'study-field__error';
  submitError.style.cssText = 'margin:0 0 10px;text-align:center';
  submitError.setAttribute('role', 'alert');
  submitError.hidden = true;
  nextBtn.parentNode.insertBefore(submitError, nextBtn);

  // ---- state ----
  var state = load();
  var tried = false;

  function isWide() { return window.innerWidth >= WIDE_MIN; }
  function minStep() { return isWide() ? 0 : -1; }

  function load() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORE));
      if (raw && raw.data) return { step: raw.step, data: sanitize(assign({}, EMPTY, raw.data)), done: !!raw.done };
    } catch (e) {}
    return { step: -1, data: assign({}, EMPTY), done: false };
  }

  // Stored state can predate the current option registry or the selection cap
  // (goals were uncapped before). Without this, >GOALS_MAX stored goals would
  // lock every card on load and leave the step unusable with no error shown.
  function sanitize(d) {
    d.goals = (Array.isArray(d.goals) ? d.goals : []).filter(isGoalKey).slice(0, GOALS_MAX);
    return d;
  }
  function save() {
    try { localStorage.setItem(STORE, JSON.stringify({ step: state.step, data: state.data, done: state.done })); } catch (e) {}
  }
  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var src = arguments[i];
      if (!src) continue;
      for (var k in src) { if (Object.prototype.hasOwnProperty.call(src, k)) target[k] = src[k]; }
    }
    return target;
  }

  function isEmail(s) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(s || '').trim()); }

  // ---- validation (mirrors prototype validate(step, data)) ----
  function validate(step) {
    var d = state.data, e = {};
    if (step === 0) {
      if (!d.email.trim()) e.email = 'Bitte gib deine E-Mail ein.';
      else if (!isEmail(d.email)) e.email = 'Diese E-Mail sieht nicht ganz richtig aus.';
      if (!d.fullName.trim()) e.fullName = 'Bitte gib deinen vollständigen Namen ein.';
    } else if (step === 1) {
      if (!d.ageRange) e.ageRange = 'Bitte eine Altersgruppe wählen.';
      if (!d.gender) e.gender = 'Bitte auswählen.';
    } else if (step === 2) {
      if (d.goals.length === 0) e.goals = 'Bitte wähle mindestens ein Ziel.';
    } else if (step === 3) {
      if (!d.pregnant) e.pregnant = 'Bitte beantworte diese Frage.';
      if (!d.medicalNone && !d.medicalNote.trim()) e.medical = 'Bitte beschreiben oder „Nichts Relevantes" abhaken.';
    } else if (step === 4) {
      if (!d.consentContact) e.consentContact = 'Erforderlich.';
    }
    return e;
  }

  // ---- rendering ----
  function show(name) {
    screens.welcome.hidden = name !== 'welcome';
    screens.form.hidden = name !== 'form';
    screens.thanks.hidden = name !== 'thanks';
  }

  function renderErrors(errs) {
    $$('[data-error]').forEach(function (el) {
      var key = el.getAttribute('data-error');
      var msg = tried ? errs[key] : null;
      if (msg) {
        if (el.classList.contains('study-checkrow__req')) { el.hidden = false; }
        else { el.textContent = msg; el.hidden = false; }
      } else {
        el.hidden = true;
      }
    });
  }

  function syncControls() {
    var d = state.data;
    // text inputs
    $$('[data-key]').forEach(function (el) {
      var k = el.getAttribute('data-key');
      if (el.value !== d[k]) el.value = d[k] || '';
    });
    // single-choice groups
    $$('[data-choice]').forEach(function (group) {
      var k = group.getAttribute('data-choice');
      group.querySelectorAll('[data-value]').forEach(function (btn) {
        var on = d[k] === btn.getAttribute('data-value');
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    });
    // multi-select (optionally capped via data-max)
    $$('[data-multi]').forEach(function (group) {
      var k = group.getAttribute('data-multi');
      var max = parseInt(group.getAttribute('data-max'), 10) || 0;   // 0 = uncapped
      var arr = d[k] || [];
      var full = max > 0 && arr.length >= max;
      group.querySelectorAll('[data-value]').forEach(function (btn) {
        var on = arr.indexOf(btn.getAttribute('data-value')) !== -1;
        var locked = full && !on;
        btn.classList.toggle('is-on', on);
        btn.classList.toggle('is-locked', locked);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
        // aria-disabled, not `disabled` — the card must stay focusable and
        // clickable so tapping it can explain why it is unavailable.
        if (locked) btn.setAttribute('aria-disabled', 'true');
        else btn.removeAttribute('aria-disabled');
      });
    });
    renderGoalMeta();
    // boolean toggles
    $$('[data-toggle]').forEach(function (btn) {
      var k = btn.getAttribute('data-toggle');
      btn.classList.toggle('is-on', !!d[k]);
      btn.setAttribute('aria-checked', d[k] ? 'true' : 'false');
    });
    // medical pre-screen interlock
    if (medicalTextarea) {
      medicalTextarea.disabled = !!d.medicalNone;
      medicalTextarea.style.opacity = d.medicalNone ? '.5' : '1';
    }
    if (pregnantNotice) pregnantNotice.hidden = d.pregnant !== 'ja';
  }

  // Selection counter + cap hint. The hint text is the accessible channel
  // (aria-live); the shake class is decoration only.
  var goalsCount = $('[data-count="goals"]');
  var goalsHint = $('[data-hint="goals"]');
  var nudgeTimer = null;

  function renderGoalMeta() {
    var n = state.data.goals.length;
    if (goalsCount) {
      goalsCount.textContent = n + ' / ' + GOALS_MAX;
      goalsCount.classList.toggle('is-full', n >= GOALS_MAX);
    }
    if (goalsHint && !nudgeTimer) {
      goalsHint.textContent = n >= GOALS_MAX
        ? 'Maximal ' + GOALS_MAX + '. Tippe eine Auswahl ab, um zu tauschen.'
        : 'Wähle bis zu ' + GOALS_MAX + '.';
    }
  }

  // Tapping a locked card refuses and explains — never silently swap out an
  // earlier pick, which reads as a bug.
  function nudgeGoals() {
    if (!goalsHint) return;
    goalsHint.textContent = 'Maximal ' + GOALS_MAX + '. Tippe eine Auswahl ab, um zu tauschen.';
    goalsHint.classList.remove('is-nudge');
    void goalsHint.offsetWidth;
    goalsHint.classList.add('is-nudge');
    clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(function () {
      goalsHint.classList.remove('is-nudge');
      nudgeTimer = null;
      renderGoalMeta();
    }, 900);
  }

  function renderForm() {
    var step = state.step;
    stepEls.forEach(function (el) {
      el.classList.toggle('is-active', parseInt(el.getAttribute('data-step'), 10) === step);
    });
    counterEl.textContent = String(step + 1);
    progressSegs.forEach(function (seg, i) {
      seg.classList.toggle('is-done', i < step);
      seg.classList.toggle('is-active', i === step);
    });
    backBtn.hidden = step <= minStep();
    nextBtn.disabled = false;                 // clear any leftover submit-in-flight lock
    var last = step === TOTAL - 1;
    nextLabel.textContent = last ? 'Bewerbung absenden' : 'Weiter';
    nextArrow.style.display = last ? 'none' : '';
    if (step === TOTAL - 1) renderSummary();
    submitError.hidden = true;
  }

  function renderSummary() {
    var d = state.data;
    var goals = d.goals.map(goalLabel).filter(Boolean).join(', ');
    var rows = [
      ['E-Mail', d.email],
      ['Name', d.fullName],
      ['Alter · Geschlecht', [d.ageRange, d.gender].filter(Boolean).join(' · ')],
      ['Ziele', goals]
    ].filter(function (r) { return r[1]; });
    summaryEl.innerHTML = rows.map(function (r) {
      return '<div class="study-summary__row"><span class="study-summary__k"></span><span class="study-summary__v"></span></div>';
    }).join('');
    var rowEls = summaryEl.querySelectorAll('.study-summary__row');
    rows.forEach(function (r, i) {
      rowEls[i].querySelector('.study-summary__k').textContent = r[0];
      rowEls[i].querySelector('.study-summary__v').textContent = r[1];
    });
  }

  function render() {
    if (state.done) { show('thanks'); renderThanks(); save(); return; }
    if (state.step === -1) { show('welcome'); save(); return; }
    show('form');
    syncControls();
    renderForm();
    renderErrors(validate(state.step));
    save();
  }

  function renderThanks() {
    var first = (state.data.fullName || '').trim().split(/\s+/)[0];
    thanksTitle.textContent = 'Danke' + (first ? ', ' + first : '') + '. Wir haben deine Bewerbung.';
  }

  // ---- navigation ----
  function go(next) { tried = false; state.step = next; if (formBody) formBody.scrollTop = 0; render(); }

  function onNext() {
    var errs = validate(state.step);
    if (Object.keys(errs).length) {
      tried = true;
      renderErrors(errs);
      // Scroll to the message, not to the top — on a long step (the goals list)
      // the error sits below the fold and jumping to the top hides it.
      var firstErr = $('.study-step.is-active [data-error]:not([hidden])');
      if (firstErr && firstErr.scrollIntoView) firstErr.scrollIntoView({ block: 'center' });
      else if (formBody) formBody.scrollTop = 0;
      return;
    }
    if (state.step === TOTAL - 1) { submit(); return; }
    go(state.step + 1);
  }

  function onBack() { if (state.step <= minStep()) return; go(state.step - 1); }

  function restart() {
    state.data = assign({}, EMPTY);
    state.done = false;
    tried = false;
    state.step = isWide() ? 0 : -1;
    render();
  }

  // ---- submission ----
  function hasMarketingConsent() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)avada_cookie_consent=([^;]+)/);
      if (!m) return false;
      var c = JSON.parse(decodeURIComponent(m[1]));
      return c && c.marketing === true;
    } catch (e) { return false; }
  }

  function fireLeadConversion(email) {
    if (!hasMarketingConsent()) return;
    var eventID = 'study_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
    var params = { content_name: 'KeraBiotic Consumer Study', content_category: 'consumer_study', value: 0, currency: 'EUR' };
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', params, { eventID: eventID }); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'generate_lead', lead_source: 'consumer_study',
        lead_content_name: params.content_name, lead_content_category: params.content_category,
        currency: params.currency, value: params.value, event_id: eventID
      });
    } catch (e) {}
  }

  function pushToKlaviyo(email) {
    var d = state.data;
    var names = (d.fullName || '').trim().split(/\s+/);
    var goalKeys = d.goals.filter(isGoalKey);
    try {
      if (window._learnq) {
        var ident = { '$email': email };
        if (names[0]) ident['$first_name'] = names[0];
        if (names.length > 1) ident['$last_name'] = names.slice(1).join(' ');
        ident['study_tag'] = TAG;
        ident['study_age_range'] = d.ageRange;
        ident['study_gender'] = d.gender;
        // Stable slugs, so rewording a label never breaks a segment; the German
        // labels ride along separately for email merge tags.
        ident['study_goals'] = goalKeys;
        ident['study_goals_labels'] = goalKeys.map(goalLabel);
        ident['study_goal_count'] = goalKeys.length;
        ident['study_marketing_optin'] = !!d.consentMarketing;
        if (d.consentMarketing) ident['$consent'] = ['email'];
        // NOTE: no eligibility flag is transmitted. It could only ever be derived
        // from the pregnancy answer, so sending it would disclose that answer
        // 1:1 — Art. 9 data, and the form promises it stays in the browser.
        // Selected testers are re-screened at onboarding per the study protocol.
        window._learnq.push(['identify', ident]);
        window._learnq.push(['track', 'KeraBiotic Study Bewerbung', {
          tag: TAG, marketing_optin: !!d.consentMarketing, url: window.location.href,
          goals: goalKeys, goal_count: goalKeys.length
        }]);
      }
    } catch (e) {}
  }

  function finish() { state.done = true; render(); }

  function submit() {
    var d = state.data;
    var email = String(d.email).trim();

    nextBtn.disabled = true;
    nextLabel.textContent = 'Wird gesendet …';
    submitError.hidden = true;

    pushToKlaviyo(email);

    // No Klaviyo list configured → test mode: keep data local, just confirm.
    if (!LIST_ID) { fireLeadConversion(email); finish(); return; }

    var body = 'g=' + encodeURIComponent(LIST_ID) + '&email=' + encodeURIComponent(email);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://a.klaviyo.com/ajax/subscriptions/subscribe', true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        fireLeadConversion(email);
        finish();
      } else {
        if (window.console && console.warn) console.warn('Klaviyo subscribe non-2xx:', xhr.status, xhr.responseText);
        nextBtn.disabled = false;
        nextLabel.textContent = 'Bewerbung absenden';
        submitError.textContent = 'Etwas ist schiefgelaufen. Bitte versuche es erneut.';
        submitError.hidden = false;
      }
    };
    xhr.send(body);
  }

  // ---- share (thank-you) ----
  function onShare() {
    var shareLabel = $('[data-share-label]');
    var shareIcon = $('[data-share-icon]');
    var payload = {
      title: 'KeraBiotic Consumer Study',
      text: 'Ich habe mich für die KeraBiotic Consumer Study von Zellaforte beworben. Kostenloses Produkt und Vitals. Bewirb dich auch!',
      url: location.href
    };
    if (navigator.share) {
      navigator.share(payload).catch(function () {});
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(payload.url).then(function () {
        shareLabel.textContent = 'Link kopiert ✓';
        if (shareIcon) shareIcon.style.display = 'none';
        setTimeout(function () {
          shareLabel.textContent = 'Teile das mit Freunden';
          if (shareIcon) shareIcon.style.display = '';
        }, 2200);
      }).catch(function () {});
    }
  }

  // ---- input wiring ----
  $$('[data-key]').forEach(function (el) {
    el.addEventListener('input', function () {
      state.data[el.getAttribute('data-key')] = el.value;
      if (tried) renderErrors(validate(state.step));
      save();
    });
  });

  $$('[data-choice]').forEach(function (group) {
    var k = group.getAttribute('data-choice');
    group.querySelectorAll('[data-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.data[k] = btn.getAttribute('data-value');
        syncControls();
        if (tried) renderErrors(validate(state.step));
        save();
      });
    });
  });

  $$('[data-multi]').forEach(function (group) {
    var k = group.getAttribute('data-multi');
    var max = parseInt(group.getAttribute('data-max'), 10) || 0;   // 0 = uncapped
    group.querySelectorAll('[data-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-value');
        var arr = state.data[k].slice();
        var idx = arr.indexOf(v);
        if (idx !== -1) arr.splice(idx, 1);
        else if (max > 0 && arr.length >= max) { nudgeGoals(); return; }
        else arr.push(v);
        state.data[k] = arr;
        syncControls();
        if (tried) renderErrors(validate(state.step));
        save();
      });
    });
  });

  $$('[data-toggle]').forEach(function (btn) {
    var k = btn.getAttribute('data-toggle');
    btn.addEventListener('click', function () {
      state.data[k] = !state.data[k];
      if (k === 'medicalNone' && state.data[k]) state.data.medicalNote = '';
      syncControls();
      if (tried) renderErrors(validate(state.step));
      save();
    });
  });

  $$('[data-action]').forEach(function (el) {
    var a = el.getAttribute('data-action');
    el.addEventListener('click', function () {
      if (a === 'start') go(0);
      else if (a === 'next') onNext();
      else if (a === 'back') onBack();
      else if (a === 'restart') restart();
      else if (a === 'share') onShare();
    });
  });

  // Submit on Enter within text fields (advance/submit the current step).
  $$('input[data-key]').forEach(function (el) {
    el.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); onNext(); } });
  });

  // resize: on desktop the marketing welcome lives in the brand panel.
  window.addEventListener('resize', function () {
    if (isWide() && state.step === -1 && !state.done) { state.step = 0; render(); }
  });

  // ---- boot ----
  if (isWide() && state.step === -1 && !state.done) state.step = 0;
  render();
})();
